// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d8a52bdc","732":"a406803c","977":"cb40e2d8"}[chunkId] + ".chunk.js";
};